// src/admin/components/UsersList.tsx
import { useOrganizationUsers } from '@/organization/useOrganizations';
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

interface UsersListProps {
  organizationId: string;
}

export function UsersList({ organizationId }: UsersListProps) {
  const { data: users, isLoading } = useOrganizationUsers(organizationId);

  if (!organizationId) {
    return (
      <Typography variant={'body1'} color={'text.secondary'}>
        Select an organization to view its users
      </Typography>
    );
  }

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <Typography variant={'h6'} gutterBottom>
        Users
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!users || users.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align={'center'}>
                  No users found
                </TableCell>
              </TableRow>
            ) : (
              users.map((user) => (
                <TableRow key={user.uuid}>
                  <TableCell>{`${user.firstName || ''} ${user.lastName || ''}`}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.username}</TableCell>
                  <TableCell>
                    {user.isSuperuser ? (
                      <Chip
                        label={'Superuser'}
                        color={'error'}
                        size={'small'}
                      />
                    ) : user.isStaff ? (
                      <Chip label={'Staff'} color={'primary'} size={'small'} />
                    ) : (
                      <Chip label={'User'} size={'small'} />
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
